import { useEffect } from 'react';
import * as Yup from 'yup-updated';
import { isCarvanaNativeApp } from '|/helpers/is-native-app';
import sendNativeEvent from '|/helpers/send-native-event';

export const useNativePlaid = ({
  onSuccess,
  onExit,
  onError
}: {
  onSuccess: () => Promise<void>;
  onExit: () => void;
  onError: () => void;
}) => {
  const isNativeApp = isCarvanaNativeApp();

  useEffect(() => {
    const handleNativeMessage = ({ data }: MessageEvent) => {
      try {
        if (typeof data !== 'string') {
          return;
        }

        const { source, event } = Yup.object({
          source: Yup.string().required(),
          event: Yup.string().required()
        }).validateSync(JSON.parse(data));

        if (source !== 'native_android' && source !== 'native_ios') {
          return;
        }

        switch (event) {
          case 'plaid_success':
            onSuccess();
            break;
          case 'plaid_exit':
            onExit();
            break;
          case 'plaid_error':
            onError();
            break;
        }
      } catch {
        // Ignore unknown messages
      }
    };

    if (isNativeApp) {
      window.addEventListener('message', handleNativeMessage);
    }

    return () => {
      if (isNativeApp) {
        window.removeEventListener('message', handleNativeMessage);
      }
    };
  }, [isNativeApp, onSuccess, onExit, onError]);

  const openNativePlaid = () => {
    sendNativeEvent({
      event: 'open_plaid',
      payload: {
        screen: 'pao'
      },
      source: 'purchase'
    });
  };

  return { isNativeApp, openNativePlaid };
};
